<div class="h-full flex flex-col overflow-hidden min-h-0">
    @if (usingUltraSocial()) {
    @if (ultra_snapchat_account()) {
    <div class="flex-1 w-full flex flex-col gap-y-2 overflow-y-auto scrollbar-hide p-1 min-h-0">
        <div class="w-full grid grid-cols-3 gap-x-2">
            <div
                class="col-span-1 p-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                <div class="shrink-0">
                    <div
                        class="relative shrink-0 size-16 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                        <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                            [src]="imageService.getImageSource(ultra_snapchat_account()!.avatarUrl, 'gallery')"></atom-ldg-img>
                    </div>
                </div>
                <div class="flex-1">
                    @if (creator.snapchatHandle) {
                    @if (snapchatHandleRevealed() && snapchatProfileUrl()) {
                    <h3 class="text-sm font-semibold text-primary">
                        <a class="hover:underline" [href]="snapchatProfileUrl()" target="_blank"
                            rel="noopener noreferrer">&#64;{{ creator.snapchatHandle.replace('@', '') }}</a>
                    </h3>
                    } @else {
                    <h3 class="text-sm font-semibold font-mono tabular-nums tracking-wide text-secondary select-none"
                        aria-label="Snapchat handle is hidden until your subscription is active.">
                        &#64;••••••••</h3>
                    <p class="text-xs text-secondary mt-0.5">Available with an active subscription.</p>
                    }
                    } @else {
                    <h3 class="text-sm font-semibold text-primary">Account Details</h3>
                    }
                    <p class="mt-1 text-gray-500 dark:text-gray-400">{{ ultra_snapchat_account()!.bio }}</p>
                </div>
            </div>

            <div
                class="col-span-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                <div class="bg-white dark:bg-gray-900 w-full">
                    <div class="grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-2 lg:grid-cols-3 dark:bg-white/10">
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Followers
                            </p>
                            <p class="flex items-baseline gap-x-2">
                                <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                    formatService.convertIntToString(ultra_snapchat_account()!.followerCount)
                                    }}</span>
                            </p>
                        </div>
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Posts</p>
                            <p class="flex items-baseline gap-x-2">
                                <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                    formatService.convertIntToString(ultra_snapchat_account()!.postCount) }}</span>
                            </p>
                        </div>
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Likes
                            </p>
                            <p class="flex items-baseline gap-x-2">
                                <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                    formatService.convertIntToString(ultra_snapchat_account()!.likesCount) }}</span>
                            </p>
                        </div>
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Views</p>
                            <p class="flex items-baseline gap-x-2">
                                <span
                                    class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                            </p>
                        </div>
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Likes</p>
                            <p class="flex items-baseline gap-x-2">
                                @if (ultra_snapchat_account()!.likesCount && ultra_snapchat_account()!.postCount) {
                                <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                    formatService.convertIntToString(ultra_snapchat_account()!.likesCount /
                                    ultra_snapchat_account()!.postCount) }}</span>
                                } @else {
                                <span
                                    class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                }
                            </p>
                        </div>
                        <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Engagement</p>
                            <p class="flex items-baseline gap-x-2">
                                <span
                                    class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if (ultra_snapchat_posts() && ultra_snapchat_posts()!.length > 0) {
        <div class="flex flex-col gap-4">
            <ul role="list" class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-4">
                @for (post of ultra_snapchat_posts(); track post.id) {
                <li
                    class="relative w-full min-w-0 bg-white dark:bg-zinc-900 rounded-lg p-2 border border-gray-200 dark:border-zinc-800 flex flex-col self-start">
                    @if (post.assetMediaUrl) {
                    <mgc-portfolio-inline-video [video]="assembledVideoObject(post)"></mgc-portfolio-inline-video>
                    } @else {
                    <div class="relative overflow-hidden rounded-lg">
                        @if (hasUltraVideoPreview(post)) {
                        <atom-video-thumbnail [videoUrl]="''" [thumbnailURL]="ultraThumbnailUrl(post)"
                            [cdnKey]="ultraThumbnailCdnKey(post)" [videoFormat]="0"></atom-video-thumbnail>
                        } @else if (ultraPostImageSrc(post)) {
                        <img [src]="ultraPostImageSrc(post)" alt="Snapchat post image"
                            class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                        } @else {
                        <img src="/assets/images/placeholder-video.png" alt="Video thumbnail unavailable"
                            class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                        }
                        @if (post.permalink) {
                        <button type="button"
                            class="absolute inset-0 flex items-center justify-center rounded-lg bg-black/20 hover:bg-black/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                            (click)="openSnapchatPost(post)" aria-label="Open Snapchat post">
                            <span
                                class="flex size-12 items-center justify-center rounded-full bg-white/90 text-accent shadow-md"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="size-6">
                                    <path fill-rule="evenodd"
                                        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>
                        }
                    </div>
                    }

                    @if (post.viewCount != null || post.likeCount != null) {
                    <p class="text-xs text-secondary mt-2">
                        @if (post.viewCount != null) {
                        {{ formatService.convertIntToString(post.viewCount) }} views
                        }
                        @if (post.likeCount != null) {
                        · {{ formatService.convertIntToString(post.likeCount) }} likes
                        }
                    </p>
                    }

                    <p class="text-xs text-secondary line-clamp-2 h-[2lh] mt-1">{{ post.caption }}</p>
                </li>
                }
            </ul>
        </div>
        } @else if (ultra_snapchat_posts() && ultra_snapchat_posts()!.length === 0) {
        <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
            <div class="text-center">
                <img class="size-10 mx-auto" src="../../../../../assets/social-icon/snapchat-logo.svg" alt="Snapchat">
                <h3 class="mt-2 text-sm font-semibold text-primary">No Snapchat posts found</h3>
                <p class="mt-1 text-sm text-secondary">Snapchat posts will appear here once they are
                    available.
                </p>
            </div>
        </div>
        } @else {
        <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
            <atom-loading-inline [title]="'Snapchat Posts'" [message]="'Loading... '"></atom-loading-inline>
        </div>
        }
    </div>
    } @else {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <atom-loading-inline [title]="'Snapchat'" [message]="'Loading account... '"></atom-loading-inline>
    </div>
    }
    } @else {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <div class="text-center">
            <img class="size-10 mx-auto" src="../../../../../assets/social-icon/snapchat-logo.svg" alt="Snapchat">
            <h3 class="mt-2 text-sm font-semibold text-primary">Snapchat account not connected</h3>
            <p class="mt-1 text-sm text-secondary">When the creator connects their Snapchat account, their account
                details will appear here.
            </p>
        </div>
    </div>
    }
</div>

<app-dialog [open]="snapchatDialogOpen()" (closed)="closeSnapchatDialog()">
    <div dialog-header>
        <h2 class="text-lg font-semibold text-primary">Snapchat post</h2>
    </div>
    <div dialog-body class="flex flex-col items-center gap-3">
        @if (snapchatPermalink()) {
        <a class="text-sm font-medium text-accent hover:underline" [href]="snapchatPermalink()" target="_blank"
            rel="noopener noreferrer">Open on Snapchat</a>
        }
    </div>
</app-dialog>
